module.exports = __webpack_public_path__ + "img/material_production_1200x800.02f39446.svg";